import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-MK-logo_svg__svg2",
  viewBox: "0 0 156.52 29.65"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-MK-logo_svg__cls-1{fill:#c1012f}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-MK-logo_svg__path6",
      d: "M36.4 2.23c10.99-3.58 23.19-2.72 33.82 1.7C75.69 6 80.45 9.61 86.07 11.31c10.16 3.26 20.99 2.82 31.52 2.53 8.62-.08 17.49 3.99 22.17 11.4-3.39-1.69-6.95-3.43-10.84-3.35-7.26-.08-13.6 3.92-20.49 5.55-4.87 1.34-9.96 1.27-14.96 1.09-4.12-.14-8.12-1.31-12.24-1.49-6.39-.44-12.73.71-19.1 1.19-20.65 1.69-41.52 2.22-62.13-.39 24.29-.24 48.9-.25 72.69-5.82 3.7-.92 7.37-2 10.84-3.58-7.74-1.85-14.77-5.68-21.41-9.96-7.53-4.96-16.75-7.19-25.72-6.24Z",
      class: "svg-MK-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-MK-logo_svg__path8",
      d: "M129.95 3.59c9.01-1.34 18.84-.33 26.56 4.82-2.62-.64-5.18-1.57-7.89-1.77-7.9-.72-15.78 1.68-22.66 5.45-1.34.94-2.96.21-4.42.09-5.15-.85-10.38-.19-15.56-.18 7.51-3.94 15.61-6.87 23.96-8.41Z",
      class: "svg-MK-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "MK-logo"}) } }